var ETelemetryType;
(function (ETelemetryType) {
    ETelemetryType["COUNTER"] = "counter";
    ETelemetryType["TIMER"] = "timer";
})(ETelemetryType = ETelemetryType || (ETelemetryType = {}));

export { ETelemetryType };
//# sourceMappingURL=types.mjs.map
